import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import NodalCashFlowUI from '../../../components/superUser/nodalTxn/NodalCashFlowUI'

const NodalCashFlowPageUI = ({
  context, errorList, accountNumber, onRefreshClick, cashFlow,
  climeTypeInflowList, climeTypeOutflowList, txnTypeInflowList, txnTypeOutflowList,
  downloadMode, onDownloadClick, onDownloadCancel,
  downloadCFMode, onDownloadCFClick, onDownloadCFCancel,
  startDate, onStartDateChange, endDate, onEndDateChange, onSubmit
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
    headerText='Cash Flow'
    page={accountNumber === '007105010733' ? '0733cf' : '4441cf'}
  // centered={!transactionList && !errorList}
  >
    {
      // !transactionList && !errorList &&
      // <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      // transactionList &&
      <NodalCashFlowUI context={context}
        accountNumber={accountNumber}
        cashFlow={cashFlow}
        climeTypeInflowList={climeTypeInflowList}
        climeTypeOutflowList={climeTypeOutflowList}
        txnTypeInflowList={txnTypeInflowList}
        txnTypeOutflowList={txnTypeOutflowList}
        onRefreshClick={onRefreshClick}
        downloadMode={downloadMode}
        onDownloadClick={onDownloadClick}
        onDownloadCancel={onDownloadCancel}
        downloadCFMode={downloadCFMode}
        onDownloadCFClick={onDownloadCFClick}
        onDownloadCFCancel={onDownloadCFCancel}
        //
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onSubmit={onSubmit}
      />
    }
  </SuperUserTxnPageUI>

export default NodalCashFlowPageUI
